import Module from './loginRedirect.js'
export default Module
